export enum LinkType {
    userConfirmation = 'confirmation',
    userPasswordRecovery = 'recovery',
}
